import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import classpage from "../views/classpage"
import searchpage from "../views/searchpage"
import recommandwill from "../views/recommandwill"
import singlebook from "../views/singlebook"
import vipread from "../views/vipread"

import ztestapp from "../views/ztestapp"

Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉url中的#
  routes: [
    {
      path: '/',
      name: 'hoem',
      component: home
    },
    //20260101 add
    {
      path: '/classpage',
      name: 'classpage',
      component: classpage
    },
    {
      path: '/searchpage',
      name: 'searchpage',
      component: searchpage
    },
    {
      path: '/recommandwill',
      name: 'recommandwill',
      component: recommandwill
    },
    {
      path: '/singlebook',
      name: 'singlebook',
      component: singlebook
    },
    {
      path: '/vipread',
      name: 'vipread',
      component: vipread
    },

    //参考测试代码，后面进行删除清理
    {
      path: '/ztestapp',
      name: 'ztestapp',
      component: ztestapp
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js